import {useUserStore} from "~/store/user.store";

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.hook('app:created', () => {
        const userStore = useUserStore()
        userStore.init()
    })
}) 